/* © CNES */
import { Image } from 'primereact/image';
import Logos from '../../../assets/images/logosToolbarDarkGeodes.png';
import './ImageContainer.scss';

/**
 * Image Container for the CNES - GEODATAHUB Logo and application title.
 * @returns ImageContainer Element.
 */
export const ImageContainer = () => {
  return (
    <div className="startContainer">
      <Image aria-label="Logos" src={Logos} alt="app_logos" width="360" />
    </div>
  );
};
